import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'minuteToTimeStructured'
})
export class MinuteToTimeStructuredPipe implements PipeTransform {

  transform(input): any {
    const sgn = Math.sign(input);
    input = Math.abs(input);
    if (input) {
      const sec_num = parseInt(input, 10); // don't forget the second param
      let days = Math.floor(sec_num / 1440);
      let hours = Math.floor((sec_num - (days * 1440)) / 60);
      let minutes = sec_num - (days * 1440) - (hours * 60);
      let output: String;
      days = this.checkDigit(days);
      hours = this.checkDigit(hours);
      minutes = this.checkDigit(minutes);
      output = `${sgn === -1 ? '-' : ''}${days}:${hours}:${minutes}`;
      return output;
    } else {
      return null;
    }
  }
  checkDigit(num) {

    if (num < 10) {
      return '0' + num;
    } else {
      return num;
    }
  }

}
